export const monthOptions = [
    {
        value:  "January",
        label:  "January"
    },
    {
        value: "February",
        label: "February"
    },
    {
        value: "March",
        label: "March"
    },
    {
        value:  "April",
        label:  "April"
    },
    {
        value:"May",
        label:"May"
    },
    {
        value:"June",
        label:"June"
    },
    {
        value: "July",
        label: "July"
    },
    {
        value:"August",
        label:"August"
    },
    {
        value:  "September",
        label:  "September"
    },
    {
        value:"October",
        label:"October"
    },
    {
        value: "November",
        label: "November"
    },
    {
        value:  "December",
        label:  "December"
    }      
  ];

export const getReportFormRow = () =>[ 
    {
        name: "month",
        type: "autocomplete",
        options: monthOptions,
        label: "Month",
        placeholder: "Select Month"
    },
    {
        name: "models",
        type: "autocomplete",
        options: monthOptions,
        label: "Engine Models",
        placeholder: "Select Engine Models"
    },
    {
        name: "region",
        type: "autocomplete",
        options: monthOptions,
        label: "Region",
        placeholder: "Select Region"
    },
    {
        name: "OEM",
        type: "autocomplete",
        options: monthOptions,
        label: "OEM",
        placeholder: "Select OEM"
    }
];